export enum HelpMessage {
  SHOW_INACTIVE = "Bocka i rutan för att visa makulerade ärenden",
  SHOW_ARCHIVED = "Bocka i rutan för att visa arkiverade ärenden",
  SEARCH = "Sökning görs i alla fält",
  ROW_NUMBER = "Välj antal ärenden som visas i listan",
  PROFILE = "Under Profil kan du ändra lösenord och välja vilka kolumner som visas",
  ROW = "Klicka på ärendet för att se detaljer",
  TITLE = "Ange en rubrik som väl beskriver ärendet",
  RT90 = "En RT90-koordinat består av 7 siffror, tex 12345678",
  ORDER_NUMBER = "Ert ordernummer",
  DESCRIPTION = "Beskrivning eller ytterligare information om ärendet",
  CUSTOMER_REFERENCE = "Er fakturareferens",
  CUSTOMER_NAME = "Namn på slutkund/felanmälare eller kontaktperson på adressen",
  CUSTOMER_PHONE = "Telefonnummer till slutkund/felanmälare eller kontaktperson på adressen",
  TECHNICIAN = "Montör som åtagit sig ärendet",
  PLANNED_START = "Datum för planerat utförande av arbetet",
  ERROR_REPORT_TYPE = 'Beskriv felet översiktligt, Tex "Trasig gatlampa"',
  ERROR_REPORT_ADDRESS = "Var har felet uppstått? En gata och ett gatunummer eller liknande. Så man kan hitta till platsen",
  ERROR_REPORT_AREA = "Var har felet uppstått? En plats eller liknande. Så man kan hitta till platsen",
  ERROR_REPORT_NAME = "Ditt namn fyller du i här",
  ERROR_REPORT_PHONE = "Ditt telefonnummer fyller du i här",
  ERROR_REPORT_DESCRIPTION = "Beskriv felet utförligare så det blir lättare att åtgärda",
}
